import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useCustomInstructionsFunctions = () => {
  const { generalApiCall } = useGeneralApiCall();

  const updateCustomInstructions = async ({ instructions, source }) => {
    try {
      const pathname = `/api/team/update-ai-assistant-constituent-response-instructions`;
      const method = 'post';
      return await generalApiCall({
        requestSource: source,
        requestProperties: { instructions },
        pathname,
        method,
        needsAuthentication: true,
        notShowErrorMessage: true,
      });
    } catch (error) {}
  };

  const removeCustomInstructions = async ({ source }) => {
    try {
      const pathname = `/api/team/remove-ai-assistant-constituent-response-instructions`;
      return await generalApiCall({
        requestSource: source,
        pathname,
        method: 'post',
        needsAuthentication: true,
        notShowErrorMessage: true,
        returnCompleteRequest: true,
      });
    } catch (error) {}
  };

  return { removeCustomInstructions, updateCustomInstructions };
};

export default useCustomInstructionsFunctions;
